import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';

import { Promotion } from '@interfaces';
// import { modals } from "@modals";
import { useStore } from '@store';

// import { faExclamationCircle } from "@icons/solid/faExclamationCircle";

export interface Props {
  promotions: Promotion[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MainSectionNavbarPromotions',
  props: {
    promotions: null
  },
  setup(__props: any) {

const props = __props as {
  promotions: Promotion[];
};



const store = useStore();

const displayMode = computed(() => store.state.displayMode);

// const hovering = ref(false);
const slide = ref(0);
const interval = ref(6_000);
const imgHeight = ref(100);

const promos = computed(() => {
  return props.promotions.map((promo) => {
    const id = promo.id;

    let displayText = '';

    if (displayMode.value === 'mobile' && promo.navbarTextMobile) {
      displayText = promo.navbarTextMobile;
    } else if (promo.navbarText) {
      displayText = promo.navbarText;
    } else if (promo.shortText) {
      displayText = promo.shortText;
    }

    const action = promo.callToAction?.fn ?? null;

    const backgroundColor = promo.navbarBackgroundColor ?? undefined;

    return { id, displayText, action, backgroundColor };
  });
});

const backgroundColor = computed(() => {
  return promos.value[slide.value]?.backgroundColor ?? '#d0571c';
});

// async function showDetails(details: string) {
//   if (!details || typeof details !== "string") return;

//   const options = {
//     title: "",
//     text: details,
//   };

//   await modals.util.generalInfo(options);
// }

function onSlideEnd(value: number) {
  slide.value = value;
}

return { __sfc: true,props, store, displayMode, slide, interval, imgHeight, promos, backgroundColor, onSlideEnd }
}

})